import(/* webpackMode: "eager", webpackExports: ["ClientAboutSection","ClientCompanyFacts","ClientConnectWithUs"] */ "/opt/build/repo/src/app/about/client-components.tsx");
